module.exports = __webpack_public_path__ + "img/10_62.ce4c26c2.png";